import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import Quill from "quill";
import { ImageHandler, VideoHandler, AttachmentHandler } from "quill-upload";
import { quillUpload, useRoles } from "../../../services/auth";
import { isSystemAdmin } from "../../../services/user";
import { attachQuillSource } from "./quillSource";
import { noH1Matcher } from "./quillNoH1";
import "quill-paste-smart";
import parse from "html-react-parser";

const InputForwardRef = (props, ref) => {
  useImperativeHandle(ref, () => ({
    returnQuill() {
      return quill;
    },
  }));

  const { column, initialValue, value, onChange } = props;
  const [quill, setQuill] = useState(null);

  const refQuill = useRef(null);
  const refSource = useRef(null);

  const canEditSource = isSystemAdmin(useRoles());

  const htmlToDelta = (html) => {
    const div = document.createElement("div");
    div.setAttribute("id", "htmlToDelta");
    div.innerHTML = `<div id="quillEditor" style="display:none">${html}</div>`;
    document.body.appendChild(div);
    const quill = new Quill("#quillEditor", {
      theme: "snow",
    });
    const delta = quill.getContents();
    document.getElementById("htmlToDelta").remove();
    return delta;
  };

  // useEffect(() => {
  // const delta = htmlToDelta(value);
  // console.log('delta', delta);
  // }, [value]);

  useEffect(() => {
    // register quill-upload
    Quill.register("modules/imageHandler", ImageHandler);
    // Quill.register("modules/videoHandler", VideoHandler);
    // Quill.register("modules/attachmentHandler", AttachmentHandler);

    setQuill(
      new Quill(`#editor-${column.field}`, {
        theme: "snow",
        // debug: "info",
        modules: {
          clipboard: {
            matchers: [noH1Matcher],
            allowed: {
              tags: [
                "a",
                "b",
                "strong",
                "u",
                "s",
                "i",
                "p",
                "br",
                "ul",
                "ol",
                "li",
                "span",
              ],
              attributes: ["href", "rel", "target", "class"],
            },
            keepSelection: true,
            substituteBlockElements: true,
            magicPasteLinks: true,
            hooks: {
              uponSanitizeElement(node, data, config) {
                console.log(node);
              },
            },
          },
          toolbar: [
            [], // toggled buttons
            [],

            // [{ header: 1 }, { header: 2 }], // custom button values
            [],
            // [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [], // outdent/indent
            // [{ direction: "rtl" }], // text direction

            // [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [],

            // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            // [{ font: [] }],
            // [{ align: [] }],

            [], // remove formatting button

            [],
          ],
          imageHandler: {
            upload: (file) => {
              // return a Promise that resolves in a link to the uploaded image
              return new Promise((resolve, reject) => {
                const fd = new FormData();
                fd.append("file", file);
                fd.append("fileName", file.name);
                fd.append("imageUrl", file.name);

                // ajax().then(data => resolve(data.imageUrl));
                quillUpload(column.id ?? 0, fd)
                  .then((response) => {
                    console.log(
                      "quillUpload",
                      response,
                      response.data.fields.imageUrl
                    );
                    if (response.data?.fields?.imageUrl) {
                      resolve(response.data.fields.imageUrl);
                    } else {
                      reject(response.data.errors);
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                    reject(err);
                  });
              });
            },
          },
          // videoHandler: {
          //   upload: file => {
          //     // return a Promise that resolves in a link to the uploaded image
          //     return new Promise((resolve, reject) => {
          //       ajax().then(data => resolve(data.videoUrl));
          //     });
          //   }
          // },
          // attachmentHandler: {
          //   upload: file => {
          //     // return a Promise that resolves in a link to the uploaded image
          //     return new Promise((resolve, reject) => {
          //       ajax().then(data => resolve(data.attachmentUrl));
          //     });
          //   }
          // },
        },
      })
    );
    return () => {
      setQuill(null);
    };
  }, []);

  useEffect(() => {
    if (quill) {
      // window.WEBSPELLCHECKER.init({
      //   container: quill.root,
      // });

      quill.on("text-change", function (delta, oldDelta, source) {
        onChange(quill);
      });
    }
  }, [quill]);

  // A HTML forrás nézet csak rendszergazdai jogosultsággal jelenik meg.
  // A jogosultság az API-ból érkezik, ezért a gomb utólag kerül a toolbarra.
  useEffect(() => {
    if (quill && canEditSource && !refSource.current) {
      refSource.current = attachQuillSource(quill, onChange);
    }
    return () => {
      if (refSource.current) {
        refSource.current.destroy();
        refSource.current = null;
      }
    };
  }, [quill, canEditSource]);

  return (
    <div>
      <div id={`editor-${column.field}`} ref={refQuill}>
        {parse(initialValue ?? "")}
      </div>
    </div>
  );
};

const QuillLightEditor = forwardRef(InputForwardRef);

QuillLightEditor.propTypes = {};

export default QuillLightEditor;
